
  import { Vue, Component, Prop } from "vue-property-decorator";
  import { SubscriptionStatus } from "@/entities/payment/SubscriptionStatus";

  @Component({})
  export default class PriceCardViewTitle extends Vue {
    @Prop({ type: String, default: undefined }) readonly label!: string;
    @Prop({ type: String, required: true }) readonly title!: string;
    @Prop({ type: String, required: true }) readonly slogan!: string;
    @Prop({ type: Boolean, default: false }) readonly withoutMinHeight!: boolean;
    @Prop({ type: Boolean, default: false }) readonly isTrial!: boolean;
    @Prop({ type: Boolean, default: false }) readonly cancelAtPeriodEnd!: boolean;
    @Prop({ type: Boolean, default: false }) readonly disabled!: boolean;
    @Prop({ type: String, default: undefined }) readonly status?: string;

    get labelStyles(): Record<string, boolean> {
      return {
        "bg-gray-400": this.disabled,
        "bg-primary-500": Boolean(this.status),
        "label__bg-secondary": !this.disabled && Boolean(!this.status),
      };
    }

    get isLabelShown(): boolean {
      return Boolean(this.status) || Boolean(this.label);
    }

    get labelText(): string {
      if (this.status) {
        if (this.status !== SubscriptionStatus.TRIALING && this.cancelAtPeriodEnd) {
          return "canceled";
        }

        return this.status.replace("_", " ");
      }

      return this.label;
    }

    get sloganStyles(): Record<string, boolean> {
      return {
        slogan: !this.withoutMinHeight,
      };
    }
  }
